import { useEffect, useRef } from 'react';
import { useOutreachOperation } from '@discovr/features';
import { toastSendFinished } from './sendFinishedToast';

/** A bulk send the admin closed the wizard on while it was still running. */
export interface AwaySend {
  operationId: string;
  scheduled: boolean;
}

interface WatcherProps {
  campaignId: string;
  send: AwaySend;
  onFinished: (operationId: string) => void;
}

function AwaySendWatcher({ campaignId, send, onFinished }: WatcherProps) {
  const operation = useOutreachOperation(campaignId, send.operationId).data;
  const reported = useRef(false);
  useEffect(() => {
    if (operation?.status !== 'done' || reported.current) return;
    reported.current = true;
    toastSendFinished(operation, send.scheduled);
    onFinished(send.operationId);
  }, [operation, send, onFinished]);
  return null;
}

/** Keeps polling the sends left behind (the wizard is gone) so their end is still toasted. Owned by the tab, not the wizard. */
export function AwaySendWatchers({ campaignId, sends, onFinished }: { campaignId: string; sends: AwaySend[]; onFinished: (operationId: string) => void }) {
  return (
    <>
      {sends.map((send) => <AwaySendWatcher key={send.operationId} campaignId={campaignId} send={send} onFinished={onFinished} />)}
    </>
  );
}
